import { jsxs } from "react/jsx-runtime";


window._jsxs = jsxs;
